import React from 'react';
import {useHeader} from '../../../../_metronic/layout';
import {useIntl} from 'react-intl';
import SubheaderBar from '../../_common/components/SubheaderBar';
import PriceQuotesPageFilters from '../components/PriceQuotesPageFilters';
import PriceQuotesPageTable from '../components/PriceQuotesPageTable';
import {PriceQuotesPageProvider} from '../components/PriceQuotesPageContext';
import {CreateLinkProvider} from '../components/CreateLinkContext';
import PopupCreateLink from '../components/PopupCreateLink/PopupCreateLink';

const PriceQuotesPage = () => {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: 'price-quotes-page-header',
    defaultMessage: 'Price quotes'
  }));

  return (
    <PriceQuotesPageProvider>
      <SubheaderBar>
        <PriceQuotesPageFilters/>
      </SubheaderBar>
      <PriceQuotesPageTable/>
      <CreateLinkProvider>
        <PopupCreateLink/>
      </CreateLinkProvider>
    </PriceQuotesPageProvider>
  );
};

export default PriceQuotesPage;
